import React, { useState, useEffect, useRef } from 'react';
import Swal from "sweetalert2";
import Axios from 'axios';
import { API_BASE_URL, INSERT_BRANDS, GET_DDL } from '../../../Config';
import { useLocation } from 'react-router-dom';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const AddBrand = () => {

    const location = useLocation();
    const [userDataSession, setUserDataSession] = useState(null);
    const [formData, setFormData] = useState({
        OrgId: "",
        Name: "",
        Description: "",
        IsDefault: 1,
        CreatedBy: "",
        UpdatedBy: 0,
        Code: "",
        ImagePath: "null",
        ImageUrl: "null",
        Type: "NULL"
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const fileInputRef = useRef(null);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if (userDataSession) {
            setFormData(prevFormData => ({
                ...prevFormData,
                OrgId: userDataSession.OrgId,
                CreatedBy: userDataSession.UserId,
            }));
        }
    }, [userDataSession]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleCancel = () => {
        setFormData({
            OrgId: userDataSession?.OrgId || "",
            Name: "",
            Description: "",
            IsDefault: 1,
            CreatedBy: userDataSession?.UserId || "",
            UpdatedBy: 0,
            Code: "",
            ImagePath: "null",
            ImageUrl: "null",
            Type: "NULL"
        });
        setSelectedFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);

        const formPayload = new FormData();
        formPayload.append('OrgId', formData.OrgId);
        formPayload.append('Name', formData.Name);
        formPayload.append('Description', formData.Description === "" ? "NULL" : formData.Description);
        formPayload.append('IsDefault', formData.IsDefault);
        formPayload.append('CreatedBy', formData.CreatedBy);
        formPayload.append('Code', formData.Code);

        if (selectedFile) {
            formPayload.append('file', selectedFile);
        }

        Axios.post(`${API_BASE_URL}${INSERT_BRANDS}`, formPayload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            setSubmitBtnLoading(false);
            if (response.data) {
                console.log(response.data, 'sssssssss')
                Swal.fire({
                    title: `Brand added Successfully.`,
                    icon: "success",
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        window.location.reload();
                    }
                });
                    if (userDataSession && userDataSession.OrgId) {
                      Axios.get(`${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`)
                        .then(response => {
                          if (response.data) {
                            const allData = response.data.ResultData;
                  
                            // Define the DDL names to filter
                            const ddlNames = ['Supplier', 'CATEGORY', 'Subcategories', 'Products', 'variantypes', 'TAX', 'Stores', 'BRAND', 'Roles', 'Staff', 'Customers', 'UNITS'];
                  
                            // Iterate through each DDL name, filter data, and save to session storage
                            ddlNames.forEach(name => {
                              const filteredData = allData.filter(item => item.DDLName === name);
                              sessionStorage.setItem(`filteredDDLData_${name}`, JSON.stringify(filteredData));
                            });
                  
                            console.log('Filtered data saved successfully');
                          } else {
                            console.error('Error fetching data:', response.data);
                          }
                        })
                        .catch(error => {
                          console.error('Error fetching data:', error);
                        });
                    }
            } else {
                Swal.fire({
                    title: "Error",
                    text: "Failed to Request Submit.",
                    icon: "error",
                });
            }
        })
        .catch(error => {
            setSubmitBtnLoading(false);
            console.error('Error adding brand:', error);
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          // Validate file type
          const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
          if (!validFileTypes.includes(file.type)) {
            setErrorMessage('Please select a valid image file (jpeg, jpg, png).');
            return;
          }
    
          // Check if file name contains spaces
          if (file.name.includes(" ")) {
            setErrorMessage('File name contains spaces. Please rename the file without spaces.');
            return;
          }
    
          // Validate file size
          if (file.size > 5 * 1024 * 1024) { // 5 MB limit
            setErrorMessage('File size exceeds 5 MB.');
            return;
          }
    
          // If everything is fine, read the file and display the image
          setErrorMessage(""); // Clear any previous errors
          const reader = new FileReader();
          reader.onloadend = () => {
            setSelectedImage(reader.result);
            setSelectedFile(file);
          };
          reader.readAsDataURL(file);
        }
    };

    const handleRemove = () => {
        setSelectedImage(null);
        setSelectedFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div>
            {(submitBtnLoading)&&(<SpinLoader/>)}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightBrandAdd"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Add Brand</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        onClick={handleRemove}
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="content">
                            <div className="">
                                <div className={`mb-3 ${(location.pathname.includes('/edit-product') || location.pathname.includes('/add-product')) ? 'mt-5' : ''}`}>
                                    <label className="form-label">Name<span className="fw-bold text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder='Name'
                                        name="Name"
                                        value={formData.Name || ''}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Code<span className="fw-bold text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder='Code'
                                        name="Code"
                                        value={formData.Code || ''}
                                        onChange={handleChange}
                                        maxLength="5"
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        className="form-control"
                                        placeholder='Description'
                                        name="Description"
                                        value={formData.Description || ''}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>
                                <div className="profile-pic-upload mb-3">
                                    <div className="profile-pic brand-pic">
                                        {selectedImage ? (
                                            <span>
                                                <img src={selectedImage} alt="Selected" />
                                            </span>
                                        ) : (
                                            <span>
                                            <img src="assets/img/brand/brand-icon-02.png" alt="Default" />
                                            </span>
                                        )}
                                        {selectedImage && (
                                            <a href="javascript:void(0);" className="remove-photo" onClick={handleRemove}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="feather feather-x x-square-add"
                                            >
                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                            </svg>
                                            </a>
                                        )}
                                        </div>
                                        <div className="image-upload mb-0">
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                                accept=".jpeg,.jpg,.png"
                                            />
                                            <div className="image-uploads">
                                                <h4>Upload Image</h4>
                                            </div>
                                        </div>
                                </div>
                                {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                                <div className="modal-footer-btn">
                                    <button
                                        type="button"
                                        className="btn btn-cancel me-2"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                        onClick={handleCancel}
                                         disabled={submitBtnLoading}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='submit'
                                        className="btn btn-submit"
                                         disabled={submitBtnLoading}
                                         
                                    >
                                        {submitBtnLoading ? 'Submitting..' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddBrand;
